module.exports = __webpack_public_path__ + "images/arrow-down-red-26d9672e.svg";